// Back to news list navigation
document.addEventListener('DOMContentLoaded', (): void => {
    initializeBackToNewsNavigation();
});

function initializeBackToNewsNavigation(): void {
    const backLinks = document.querySelectorAll<HTMLAnchorElement>('.back-to-newsList');
    
    backLinks.forEach((backLink: HTMLAnchorElement): void => {
        backLink.addEventListener('click', handleBackNavigation);
    });
}

function handleBackNavigation(event: MouseEvent): void {
    event.preventDefault();
    
    const target = event.currentTarget as HTMLAnchorElement;
    const fallbackUrl = target.getAttribute('href');
    
    if (shouldUseHistoryBack()) {
        window.history.back();
    } else {
        navigateToFallback(fallbackUrl);
    }
}

function shouldUseHistoryBack(): boolean {
    const referrer: string = document.referrer;
    const hasHistory: boolean = window.history.length > 1;
    const isFromNewsPage: boolean = referrer.includes('was-es-neues-gibt');
    
    return hasHistory && isFromNewsPage;
}

function navigateToFallback(url: string | null): void {
    if (url) {
        window.location.href = url;
    } else {
        console.error('No fallback URL provided for back navigation');
    }
}